import React from 'react';
import { InputText, Button } from '@insurancemenu/imenu-components-lib';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { CODE_MESSAGE } from 'global/utils/codeMessages';
import SubtitleWithLines from 'components/common/SubtitleWithLines';
import { EXTERNAL_IM_LINKS } from 'global/utils/generalLinks';
import ErrorMessage from 'components/common/ErrorMessage';
import SupportBlock from 'components/common/SupportBlock';
import { createStyles } from './styles';

const SignInForm = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    signInFormStore: { signInForm, loading, errorCode, signIn, setErrorCode },
  } = useRootStore();

  const onSignIn = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    void signIn();
  };

  const ForgotPasswordLink = (
    <Link to="/forgot-password" className={classes.forgotLink}>
      <Button
        type="text"
        color="primary"
        className={classes.forgotButton}
        onClick={(): void => {
          signInForm.resetForm();
          setErrorCode(null);
        }}
      >
        Forgot password?
      </Button>
    </Link>
  );

  const ManyLoginsErrorMessage = (
    <>
      You&apos;ve attempted too many logins. Please <Link to="/forgot-password">reset your password.</Link>
    </>
  );

  return (
    <form id="authorization-form" onSubmit={onSignIn} className={classes.form}>
      <SubtitleWithLines text="Please fill out the form below to get started" className={classes.subtitle} />

      <div className={classes.formElements}>
        <InputText
          label="Email Address"
          name="email"
          value={signInForm.fields.email.value}
          onChange={signInForm.onFieldChange}
          className={classes.input}
        />
        <InputText
          label="Password"
          name="password"
          value={signInForm.fields.password.value}
          onChange={signInForm.onFieldChange}
          htmlType="password"
          description={ForgotPasswordLink}
          className={classes.input}
        />
      </div>
      <div className={errorCode ? classes.buttonWrapperWithError : classes.validButtonWrapper}>
        {errorCode && <ErrorMessage error={errorCode === 231 ? ManyLoginsErrorMessage : CODE_MESSAGE[errorCode]} />}
        <Button
          htmlType="submit"
          color="primary"
          className={classes.button}
          disabled={loading || !signInForm.isFormValid()}
        >
          Sign in
        </Button>
      </div>

      <div className={classes.infoText}>
        By using this site, you agree to our<a href={EXTERNAL_IM_LINKS.TERMS_OF_USE}>Terms of Use</a>and
        <a href={EXTERNAL_IM_LINKS.PRIVACY_POLICY}>Privacy Policy</a>
      </div>
      <SubtitleWithLines text="or" narrow />
      <SupportBlock type="NEW_TO_IM" />
    </form>
  );
});

export default SignInForm;
